<template>
  <BaseBar :key="key" :gradient="survey.progress" class="accordion-item">
    <div class="text-white text-uppercase accordion-header">
      <div class="row">
        <div class="d-flex col hover-pointer" @click="goToSurvey()">
          <div class="d-flex-column-center">{{ survey.name }}</div>
        </div>
        <div
          class="col d-flex-column-center items-center hover-pointer"
          @click="goToSurvey()"
        >
          <span>{{ survey.progress }}%</span>
        </div>
        <div class="col single-survey-action">
          <div
            class="d-flex-column-center items-center hover-pointer"
            @click="goToSurvey()"
          >
            <span>{{ survey.score }}</span>
            <small class="text-uppercase">points</small>
          </div>
          <div
            class="d-flex-column-center items-center mx-2 hover-pointer"
            @click="goToSurvey()"
          >
            <small>Créé le</small>
            <span>{{ $date(survey.created_at).format('ll') }}</span>
          </div>
          <div
            class="d-flex-column-center items-center mx-2 hover-pointer"
            @click="goToSurvey()"
          >
            <small>Mis à jour le</small>
            <span>{{ $date(survey.updated_at).format('ll') }}</span>
          </div>
          <div
            class="ps-2 d-flex-column-center hover-pointer"
            @click="expand(key, $event)"
          >
            <bs-tooltip title="Éditer">
              <AppIcon icon="edit" />
            </bs-tooltip>
          </div>
          <div
            class="ps-2 d-flex-column-center hover-pointer"
            @click="exportToPdf()"
          >
            <bs-tooltip title="Exporter en PDF">
              <AppIcon icon="pdf" />
            </bs-tooltip>
          </div>
          <div
            class="ps-2 hover-pointer d-flex-column-center mx-2"
            @click="deleteReport(key, survey)"
          >
            <bs-tooltip title="Supprimer">
              <AppIcon icon="delete" />
            </bs-tooltip>
          </div>
        </div>
      </div>
    </div>
    <div :ref="'accordion-body-' + key" class="accordion-body text-primary p-0">
      <div class="accordion-content py-3">
        <form @submit.prevent="saveReport(key, $event, survey)">
          <div class="form-floating mb-3">
            <input
              :id="`survey-name-${key}`"
              v-model="form.name"
              type="text"
              class="form-control"
              placeholder="Titre du questionnaire"
            />
            <label :for="`survey-name-${key}`"> Titre du questionnaire </label>
            <div v-if="errors.name" class="field-error">{{ errors.name }}</div>
          </div>
          <div class="form-floating">
            <textarea
              :id="`survey-description-${key}`"
              v-model="form.description"
              class="form-control h-100"
              placeholder="Description"
              rows="4"
            >
            </textarea>
            <label :for="`survey-description-${key}`"> Description </label>
            <div v-if="errors.description" class="field-error">
              {{ errors.description }}
            </div>
          </div>
          <div class="my-2 d-flex justify-content-end">
            <button
              class="btn btn-light me-3"
              type="button"
              @click="cancel(key, $event)"
            >
              Annuler
            </button>
            <button
              class="btn btn-success"
              type="submit"
              :disabled="form.processing"
            >
              Sauvegarder
            </button>
          </div>
        </form>
      </div>
    </div>
  </BaseBar>
</template>

<script>
import BaseBar from '../Components/BaseBar.vue'
import BsTooltip from './BsTooltip.vue'
import { saveAs } from 'file-saver'
import axios from 'axios'
export default {
  components: { BaseBar, BsTooltip },
  props: {
    errors: {
      type: Object,
      default() {
        return {}
      },
    },
    survey: {
      type: Object,
      default() {
        return {
          id: 0,
          name: '',
          description: '',
          progress: 0,
          score: 0,
          created_at: '',
          updated_at: '',
        }
      },
    },
  },
  data() {
    return {
      key: this.survey.id,
      active: false,
      form: this.$inertia.form({
        name: this.survey.name,
        description: this.survey.description,
      }),
    }
  },
  methods: {
    goToSurvey() {
      return this.$inertia.visit(
        this.$route('survey.user.summary', { id: this.survey.id })
      )
    },
    expand(key, $event) {
      $event.preventDefault()

      const el = this.$refs['accordion-body-' + key]

      if (this.active === false) {
        this.active = true

        this.gsap.to(el, 0.3, {
          height: el.scrollHeight,
          ease: 'ease.out( 1, 0.3)',
        })
      } else {
        this.active = false
        this.gsap.to(el, 0.3, {
          height: 0,
          ease: 'ease.in(1.2, 0.8)',
        })
      }
    },
    close(key, $event) {
      this.expand(key, $event)
    },
    cancel(key, $event) {
      this.resetFormWithPreviousValues()
      this.close(key, $event)
    },
    saveReport(key, $event, survey) {
      this.$toasted.global.saving()
      try {
        this.form.put(this.$route('survey.user.update', survey.id), {
          onSuccess: () => {
            this.close(key, $event)
            this.$toasted.global.saved()
          },
        })
      } catch (error) {
        this.$toasted.global.savingError()
        console.error(error)
      }
    },
    async exportToPdf() {
      this.$toasted.global.exporting()

      try {
        await this.getPdfFile()
        this.$toasted.global.exported()
      } catch (error) {
        this.$toasted.global.exportingError()
        console.error(error)
      }
    },
    deleteReport(key, survey) {
      if (confirm('Êtes-vous certain de vouloir supprimer ce sondage?')) {
        this.$toasted.global.deleting()
        try {
          this.$inertia.delete(this.$route('survey.user.delete', survey.id), {
            onSuccess: () => {
              this.$toasted.global.deleted()
            },
          })
        } catch (error) {
          this.$toasted.global.deleteError()
          console.error(error)
        }
      }
    },
    resetFormWithPreviousValues() {
      this.form.reset('name', 'description')
    },
    async getPdfFile() {
      const response = await axios({
        url: this.$route('survey.user.exportToPdf', this.survey.id),
        data: [],
        method: 'POST',
        responseType: 'blob',
      })
      const header = response.headers['content-disposition']
      const filename = header
        .split(';')[1]
        .split('=')[1]
        .replace('"', '')
        .replace('"', '')

      return saveAs(new Blob([response.data]), filename)
    },
  },
}
</script>

<style scoped>
.accordion-body {
  height: 0;
  overflow: hidden;
}
.single-survey-action {
  display: grid;
  grid-template-columns: 8em 8em 8em 3em 3em 3em;
  width: 100%;
  place-items: center;
  place-content: end;
}

.field-error {
  color: var(--bs-danger);
}
small {
  font-size: 0.675em;
}
</style>
